import { Box, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

type DrawerFooterProps = {
  children: ReactNode;
  sx?: SxProps<Theme>;
};

export default function DrawerFooter({ children, sx }: DrawerFooterProps) {
  return (
    <Box
      component="footer"
      sx={{
        position: 'sticky',
        bottom: 0,
        py: 2,
        mt: 2,
        borderTop: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        zIndex: 1, // sit above scrolling content
        ...sx
      }}
    >
      {children}
    </Box>
  );
}

// Add displayName for more reliable component detection
DrawerFooter.displayName = 'DrawerFooter';
